import { ArrowTopRightOnSquareIcon, ChevronRightIcon, DocumentIcon } from "@heroicons/react/24/outline";
import React from "react";

const TermsAndConditions: React.FC = () => {
  const linkItems = [
    { text: "Definitions and Interpretation", icon: ChevronRightIcon, target: "Definitions-Interpretation" },
    { text: "The Agreement and Wallet", icon: ChevronRightIcon, target: "introduction" },
    { text: "Applying for a Wallet", icon: ChevronRightIcon, target: "applying-for-wallet" },
    { text: "Wallet User and Contract Holder Details", icon: ChevronRightIcon, target: "wallet-user-details" },
    { text: "Using the Wallet", icon: ChevronRightIcon, target: "using-the-wallet" },
    { text: "Third-Party Access to the Wallet", icon: ChevronRightIcon, target: "third-party-access" },
    { text: "Using the Wallet (2)", icon: ChevronRightIcon, target: "using-the-wallet-2" },
    { text: "Authorising Transactions", icon: ChevronRightIcon, target: "authorising-transactions" },
    { text: "Managing and Protecting the Wallet", icon: ChevronRightIcon, target: "managing-protecting-wallet" },
    { text: "Termination of this Agreement", icon: ChevronRightIcon, target: "termination" },
    { text: "Foreign Exchange", icon: ChevronRightIcon, target: "foreign-exchange" },
    { text: "Corporate Opt-Out", icon: ChevronRightIcon, target: "corporate-opt-out" },
    { text: "Our Liability", icon: ChevronRightIcon, target: "our-liability" },
    { text: "Complaints", icon: ChevronRightIcon, target: "complaints" },
    { text: "General Communication", icon: ChevronRightIcon, target: "general-communication" },
    { text: "Personal Data", icon: ChevronRightIcon, target: "personal-data" },
    { text: "Changes to this Agreement", icon: ChevronRightIcon, target: "right-to-change" },
    { text: "Language", icon: ChevronRightIcon, target: "language" },
    { text: "Governing Law", icon: ChevronRightIcon, target: "governing-law" },
    { text: "Jurisdiction", icon: ChevronRightIcon, target: "jurisdiction" },
    { text: "Miscellaneous", icon: ChevronRightIcon, target: "miscellaneous" },
    { text: "Schedule", icon: ChevronRightIcon, target: "schedule" },
  ];

  return (
    <div className="flex flex-col items-center container pt-20">
      {/* Header Section */}
      <header className="w-full px-5">
        <div className="flex items-center flex-wrap gap-4 justify-between">
          <h1 className="text-4xl font-extrabold text-gray-900">Terms and Conditions Orenda</h1>
          <a
            href="/legal/Orenda-Corporate-Wallet-Ts-Cs.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center text-blue-600 my-4 gap-1 nc-Button flex-shrink-0 relative h-auto justify-center rounded-full transition-colors border-transparent bg-transparent ring-1 ring-blue-600 hover:bg-transparent hover:text-blue-600 text-sm sm:text-base font-medium py-3 px-4 sm:px-6   "
          >
            <DocumentIcon className="w-4 h-4" />
            Downloadable Version
          </a>
        </div>
        <p className="mt-4 text-lg text-gray-700">Version: 1.0 - Last updated on 22nd May 2025</p>
        <p className="mt-2 text-gray-600">
          These terms and conditions of use (“Wallet Terms”), and the provisions of the schedule (“Schedule”), in relation to the use of the corporate Wallet issued by Transact Payments Limited (“TransactPay”) (collectively the “Agreement”)
          constitute a binding agreement between You and TransactPay.
        </p>
        <p className="mt-2 text-gray-600">
          You will be asked to confirm Your acceptance of this Agreement when You apply for a Wallet via the Corporate Account Platform. If You refuse to accept this Agreement, then Program Manager will not be able to open a Wallet for you. The
          Agreement will be governed by the Wallet Terms and Schedule in force as displayed on the Website/App.
        </p>
      </header>

      {/* Link Section */}
      <div className="w-full mt-8 bg-gray-100 rounded-lg p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {linkItems.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <a key={index} href={`#${item.target}`} className="flex items-center justify-between bg-white p-4 rounded-lg shadow-md hover:bg-gray-50 transition">
                <span className="text-gray-900 font-medium">{item.text}</span>
                <IconComponent className="h-6 w-6" />
              </a>
            );
          })}
        </div>
      </div>

      {/* Sections */}
      <section id="Definitions-Interpretation" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">1. Definitions and Interpretation:</h3>
        <div className="space-y-4">
          <p className="text-gray-800 pt-2">
            <strong>Account Information Service Provider</strong> a third-party payment service provider which is authorised by a financial regulator to provide online account information services and which, if you allow it, will be able to access
            certain online account information in the Wallet, such as the payments you make and receive;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>App </strong>the mobile application provided by Orenda that allows you to access the Wallet and take actions, such as making payments, viewing your Transaction history, blocking the Wallet and raising queries with Customer
            Services;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Applicable Law </strong> any law (including but not limited to, any local law of the jurisdictions into which the Wallet is provided and the Program is operated), statute, statutory instrument, act, regulation, rule, order,
            supervisory guidance, policy, instruction or requirement stipulated by an applicable Regulatory Authority, or interpretation published by any Regulatory Authority, any order issued by a court which has jurisdiction over you, us, Program
            Manager, or any rule or requirement related to the Wallet and/or any of the services to be provided under this Agreement or such other rule that we consider to be valid and as amended from time to time;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Available Balance</strong> the value of unspent funds loaded onto the Wallet and available for you to use;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Business Day</strong> Monday to Friday, 9am to 5pm CET, excluding bank and public holidays in Gibraltar;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>CHAPS</strong> the Clearing House Automated Payment System, a service which allows organisations to make same-day payments to an account within the UK, within the CHAPS operating days and times;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Contract Holder</strong> You, the corporate entity to whom the Wallet is provided and which, subject to its Corporate Account Platform agreement, owns the available funds that can be used by the Wallet User;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Corporate Account Platform</strong> the online platform where a Wallet can be requested and funds loaded for use by the Wallet Users. Use of the Corporate Account Platform is regulated by an agreement entered into between the
            Contract Holder and Orenda;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Denominated Currency</strong> has the meaning given to it in the Schedule.
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Direct Debit</strong> a payment collected via the UK Direct Debit scheme from or to your Wallet;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Faster Payments</strong> a service which allows you to make and receive electronic payments in the UK. The payment is received by the recipient organisation or bank within 2 hours, as long as the receiving organisation or bank is
            part of the Faster Payments Scheme;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Fee</strong> any fee payable by you as referenced in the Fee Schedule;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Fee Schedule</strong> the schedule contained in this Agreement; occurs, with respect to any party, in the event of:
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Insolvency Event</strong> (a) that party passing a resolution, or a court making an order, that that party be wound up (except for the purposes of a bona fide, solvent reconstruction or amalgamation);
            <br />
            (b) an order being made for the appointment of an administrator in relation to that party or a receiver, administrative receiver or manager being appointed over all or any part of that party's assets or undertaking;
            <br />
            (c) that party being unable to pay its debts within the meaning of section 123 of the UK Insolvency Act 1986;
            <br />
            (d) there being proposed in respect of that party any voluntary arrangement under [section 1 of the UK Insolvency Act 1986 or any compromise or arrangement under Part 26 of the UK Companies Act 2006; or
            <br />
            (e) any circumstances occurring that are the equivalent of (a) to (d) above under the legislation and related case law and practice applicable to that party (where (a) to (d) above do not apply for any reason to that party;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Microenterprise</strong> an entity engaged in any economic activity, irrespective of its legal form, which employs fewer than 10 persons and whose annual turnover and/or annual balance sheet does not exceed EUR 2 million or
            currency equivalent;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Payment Initiation Services Provider</strong> a third-party payment service provider which is authorised by a financial regulator to provide an online service to make a payment from your Wallet at your request;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Personal Details / Personal Data</strong> any registered personal identity details relating to the use of the Wallet, App and Corporate Account Platform including (but not limited to) an individual’s: name, date of birth, home
            address, email address and telephone (landline and/or mobile) number. Full details of the Personal Data which we process are set out in our Privacy Policy;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Program</strong> the marketing, processing, administration, supervision, maintenance, servicing, authorisation or usage of the Wallet and any other payment services established in accordance with this Agreement;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Program Manager / Orenda</strong> Orenda Financial Services Limited, incorporated and registered in England with company number 12404984 and registered office at St Martins House, 1 Gresham Street, London, England, EC2V 7BX;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>PSRs</strong> The Gibraltar Financial Services (Payment Services) Regulations 2020.
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Regulatory Authority</strong> the Gibraltar Financial Services Commission (which is the body which grants our e-money licence and supervises our actions) and/or any regulator or agency which has authority over us or Program
            Manager in relation to the Wallet, Program or any services provided under this Agreement;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Security Details</strong> certain information, including but not limited to Username and Password for the Wallet, used by You on behalf of the Wallet User in order to access the Wallet and authorise Transactions;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Third-Party Provider / TPP</strong> an Account Information Service Provider or a Payment Initiation Service Provider;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Transaction</strong> any debit, credit or adjustment to a Wallet that affects the balance of funds held in it;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Username and Password</strong> a set of personal codes selected by you in order to access the App;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Wallet</strong> the electronic money account provided to you by TransactPay and opened in accordance with this Agreement;
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Wallet User</strong> an individual to whom access to a Wallet is provided and who is validly authorised by You to use and to utilise funds loaded onto a Wallet subject to this Agreement and on Your behalf.
          </p>
          <p className="text-gray-800 pt-2">
            <strong>Website</strong>{" "}
            <a href="https://orenda.finance/" className="text-blue-500" target="_blank" rel="noopener noreferrer">
              https://orenda.finance/
            </a>
          </p>
          <p className="text-gray-800 pt-2">
            <strong>we, us or our</strong> Transact Payments Limited (“TransactPay”), a company incorporated in Gibraltar with registered address at 6.20 World Trade Center, 6 Bayside Road, Gibraltar, GX11 1AA, company registration number 108217 and
            which is authorised by the Gibraltar Financial Services Commission as an electronic money institution; and
          </p>
          <p className="text-gray-800 pt-2">
            <strong>you or your</strong> the Contract Holder of the Wallet and, as applicable, the Wallet User on the Contract Holder’s behalf.
          </p>
        </div>
      </section>

      <section id="introduction" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">2. The Agreement and Wallet</h3>
        <p className="text-gray-800">
          <strong>2.1.</strong> The Wallet is an electronic money account provided by us in accordance with our licence granted by the Gibraltar Financial Services Commission. The Wallet is issued by us at the Contract Holder’s request and upon
          acceptance of said request to Program Manager via the Corporate Account Platform. You must use the Wallet in accordance with this Agreement.
        </p>
        <p className="text-gray-800">
          <strong>2.2.</strong> The Contract Holder shall be liable for all acts and omissions of Wallet Users purported to be carried out pursuant to the activities anticipated by this Agreement. The Contract Holder warrants, represents and
          undertakes that it shall ensure that all Wallet Users are made aware of the content of this Agreement and the obligations regarding the use of the Wallet.
        </p>
        <p className="text-gray-800">
          <strong>2.3.</strong> The Contract Holder shall contractually ensure that Wallet Users are not permitted to use the Wallet unless such use has been authorised by the Contract Holder.
        </p>
        <p className="text-gray-800">
          <strong>2.4.</strong> There is no interest payable to you on the Available Balance of the Wallet and the Available Balance does not amount to a deposit with us.
        </p>
        <p className="text-gray-800">
          <strong>2.5.</strong> The Wallet is to be used for business purposes only.
        </p>
        <p className="text-gray-800">
          <strong>2.6.</strong> You must ensure that you have sufficient available funds in your accounts to carry out any transaction you wish to make. Some transactions that would take your available funds below zero may still go through and if
          that happens, we will let you know the amount that you will need to repay us before the end of the day. We may block your accounts if such a negative balance is not rectified immediately.
        </p>
        <p className="text-gray-800">
          <strong>2.7.</strong> You are responsible for any taxes which may be applicable to your transactions and it is your responsibility to collect, report and pay the correct tax to the appropriate tax authority.
        </p>
      </section>

      <section id="applying-for-wallet" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">3. Applying for a Wallet</h3>
        <p className="text-gray-800">
          <strong>3.1.</strong> To apply for, and use, a Wallet you must be incorporated in a Permitted Territory (as defined in the Schedule).
        </p>
        <p className="text-gray-800">
          <strong>3.2.</strong> The Contract Holder must provide TPML with the names of all Wallet Users upon request and the Contract Holder agrees that each such Wallet User has authority to operate the Wallets on its behalf.
        </p>
        <p className="text-gray-800">
          <strong>3.3.</strong> The Contract Holder will ensure that:
        </p>
        <ul className="list-disc pl-5 text-gray-800">
          <li>all relevant background and due diligence checks, including KYC, AML and PEP checks, have been conducted in relation to the Wallet Users; and</li>
          <li>the Wallet Users have the necessary skill sets to manage the Contract Holder’s use of the Wallet.</li>
        </ul>
      </section>

      <section id="wallet-user-details" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">4. Wallet User and Contract Holder Details</h3>
        <p className="text-gray-800">
          <strong>4.1.</strong> You must notify Program Manager of any change in a Wallet User’s Personal Details or details relating to the Contract Holder (for example, change of registered office address or change in ownership) as soon as possible
          by contacting Customer Services. You will have to pay for any loss that happens directly as a result of any delay in telling us that such information has changed or if you have not told us because you’ve been grossly negligent or committed
          fraud. We will need to verify the new information Details and may request relevant KYC information/documents from you.
        </p>
        <p className="text-gray-800">
          <strong>4.2.</strong> We, or Program Manager, reserve the right at any time to satisfy ourselves that your Personal Details are correct (for example, by requesting relevant original documents) including so that we can prevent fraud and/or
          money laundering. You also agree to authorise us and Program Manager to undertake electronic identity verification checks on you either directly ourselves or using relevant third-party companies at the time when you apply for a Wallet or at
          any time in the future.
        </p>
      </section>

      <section id="using-the-wallet" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">5. Using the Wallet</h3>
        <p className="text-gray-800">
          <strong>5.1.</strong> You can use the Wallet subject to the Fees which you can find in the Fee Schedule. The Fees will be deducted from the Available Balance as they are charged to you.
        </p>
        <p className="text-gray-800">
          <strong>5.2.</strong> You can receive funds into the Wallet by electronic funds transfer using CHAPS, Faster Payments and any other payment type as notified by us to you from time to time. We will credit the Wallet when we receive the
          funds.
        </p>
        <p className="text-gray-800">
          <strong>5.3.</strong> The Wallet can also receive internal transfers from other Wallets owned or controlled by you, which apply instantly.
        </p>
        <p className="text-gray-800">
          <strong>5.4.</strong> The Wallet will not be credited if:
          <ul className="list-disc pl-5">
            <li>the Wallet is suspended, restricted or terminated;</li>
            <li>the sender has provided incorrect/invalid Wallet details for the Wallet;</li>
            <li>we suspect the transfer to be fraudulent; or</li>
            <li>allowing the transfer to proceed would be against any legal obligations that we are required to comply with.</li>
          </ul>
        </p>
        <p className="text-gray-800">
          <strong>5.5.</strong> If we are unable to credit the Wallet for any of the reasons in clause 5.4 then the funds may be sent back to the sender without us notifying you beforehand.
        </p>
        <p className="text-gray-800">
          <strong>5.6.</strong> In order to manage our risk, particularly with respect to money laundering, fraud or security concerns, we also apply internal controls, including limits, delays and blocks, to certain types of payment. We change these
          as necessary but for security purposes, we may or may not disclose them to you.
        </p>
        <p className="text-gray-800">
          <strong>5.7.</strong> You can send funds from the Wallet to external bank accounts using CHAPS, Faster Payments and other methods which we notify you about from time to time.
        </p>
        <p className="text-gray-800">
          <strong>5.8.</strong> If for any reason whatsoever a Transaction is carried out, but the amount is greater than the Available Balance, you must pay us the difference immediately. If you don’t pay us after receiving a notification from us,
          we reserve the right to take all necessary steps to recover the difference, including taking legal action. We may charge the amount of the difference against any funds on the Wallet, including any funds that are loaded at a later date. We
          may arrange for the Wallet to be suspended until we are reimbursed with the difference.
        </p>
        <p className="text-gray-800">
          <strong>5.9.</strong> The Wallet will be terminated if you use it for any illegal purposes, in accordance with clause 10.4(b)iv.
        </p>
        <p className="text-gray-800">
          <strong>5.10.</strong> You are not permitted to set up Direct Debits from the Wallet.
        </p>
      </section>

      <section id="third-party-access" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">6. Third-Party Access to the Wallet</h3>
        <p className="text-gray-800">
          <strong>6.1.</strong> You can allow a Third-Party Provider (also referred to as a ‘TPP’ or ‘Open Banking Provider’) to have access to the information in the Wallet or to initiate certain Transactions from the Wallet. The TPP must be
          authorised to provide these services to you, and we recommend that you check their authorisation on their regulator’s register of authorised providers before using them.
        </p>
        <p className="text-gray-800">
          <strong>6.2.</strong> When you use a TPP, you authorise and consent to them accessing the Wallet or making payments from the Wallet on your behalf. Once the TPP properly identifies itself to us, we will treat any instruction from the TPP as
          if it was an instruction from you. You also consent to us sharing any information (including Personal Data) with the TPP that is reasonably required for them to provide their services to you.
        </p>
        <p className="text-gray-800">
          <strong>6.3.</strong> We may deny a TPP access to the Wallet or to make a payment if we are concerned about unauthorised or fraudulent access by that TPP. If we do block access, we will tell you beforehand or as soon as possible afterwards
          in a way that we consider the most appropriate. We won’t tell you if Applicable Law prevents us from doing so or if there are valid security reasons for not informing you. We will unblock access to the TPP when the reasons for blocking no
          longer exist.
        </p>
        <p className="text-gray-800">
          <strong>6.4.</strong> You also have the right to block or withdraw access to the Wallet by the TPP and you should contact Customer Services if you wish to do this.
        </p>
      </section>

      <section id="using-the-wallet-2" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">7. Using the Wallet</h3>
        <p className="text-gray-800">
          <strong>7.1.</strong> You can use the Wallet subject to the Fees which you can find in the Fee Schedule. The Fees will be deducted from the Available Balance as they are charged to you.
        </p>
        <p className="text-gray-800">
          <strong>7.2.</strong> Unless we tell you otherwise, you can login to the Wallet anywhere.
        </p>
        <p className="text-gray-800">
          <strong>7.3.</strong> You must not use the Wallet for any illegal purposes (and if you do, you will breach an important part of this Agreement which means that we can suspend the Wallet, restrict its functionality or terminate this
          Agreement with immediate effect under clause 10.4(b)(x).
        </p>
      </section>

      <section id="authorising-transactions" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">8. Authorising Transactions</h3>
        <p className="text-gray-800">
          <strong>8.1.</strong> You must give your consent to each Transaction by a) entering your Security Details; or b) authorising a TPP to initiate a Transaction. Once you have given such consent to the Transaction, we will consider it to be
          authorised by you.
        </p>
        <p className="text-gray-800">
          <strong>8.2.</strong> When you make a Transaction, we consider it to be received when it is received by our processing partner.
        </p>
        <p className="text-gray-800">
          <strong>8.3.</strong> Once a Transaction has been authorised by you and received by us, it cannot be reversed.
        </p>
        <p className="text-gray-800">
          <strong>8.4.</strong> Your ability to use or access the Wallet may occasionally be interrupted, for example, if Program Manager or any third-party service providers need to carry out maintenance on their systems or websites. Please contact
          Customer Services should you experience any problems using the Wallet and these will be resolved as soon as possible.
        </p>
        <p className="text-gray-800">
          <strong>8.5.</strong> You may obtain information regarding Transactions and the Available Balance via the App.
        </p>
      </section>

      <section id="managing-protecting-wallet" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">9. Managing and Protecting the Wallet</h3>
        <p className="text-gray-800">
          <strong>9.1.</strong> When opening a Wallet, you shall be prompted to create a password that will be used by you to access it. You are responsible for the Wallet, device, App and any related Username and Passwords, logins or other Security
          Details and you must take all possible measures to keep them safe and entirely confidential. Examples of these measures include (but are not limited to):
        </p>
        <ul className="list-disc pl-5 text-gray-800">
          <li>never letting any other person use your Security Details;</li>
          <li>never writing your Security Details down in a way that allows anyone else to recognise them;</li>
          <li>complying with any reasonable instructions We give about keeping the Wallet safe and secure; and</li>
          <li>reporting unauthorised access to the Wallet or to any Security Details to any relevant organisations to warn them of any potential attempts to commit identity fraud in Your name.</li>
        </ul>
        <p className="text-gray-800">
          Failure to comply with this clause may affect your ability to claim any losses in the event that we can show that you have intentionally failed to keep the information safe or you have acted fraudulently, with undue delay or with gross
          negligence.
        </p>
        <p className="text-gray-800">
          <strong>9.2.</strong> If you believe that someone else knows any of your Security Details, you must notify us by contacting Customer Services immediately.
        </p>
        <p className="text-gray-800">
          <strong>9.3.</strong> You must tell us about any unauthorised or incorrectly executed Transactions immediately.
        </p>
        <p className="text-gray-800">
          <strong>9.4.</strong> If we suspect or believe that there may be a security threat or a threat of fraud to the Wallet, Program Manager will notify you securely via email.
        </p>
      </section>

      <section id="termination" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">10. Termination of this Agreement</h3>
        <p className="text-gray-800">
          <strong>10.1.</strong> Unless this Agreement is terminated by you or by us, it shall remain in force.
        </p>
        <p className="text-gray-800">
          <strong>10.2.</strong> When this Agreement is terminated, the Wallet will be closed, and you are not permitted to use it.
        </p>
        <p className="text-gray-800">
          <strong>10.3.</strong> The Agreement may be terminated at any time by the Contract Holder by sending 30 days’ written notice to Customer Services or by Us, or Program Manager for Us, sending 30 days’ written notice to You at the email
          address that you have provided to Us.
        </p>
        <p className="text-gray-800">
          <strong>10.4.</strong> We, or Program Manager for us, can suspend the Wallet, restrict its functionality or terminate this Agreement at any time with immediate effect if:
        </p>
        <ul className="list-disc pl-5 text-gray-800">
          <li>you haven’t given us the information we need or we believe that any of the information that you have provided to us was incorrect or false;</li>
          <li>you do not pay money that you owe to us;</li>
          <li>you fail to provide the Personal Data necessary for us to comply with our legal or regulatory obligations and to fulfil this Agreement;</li>
          <li>we reasonably suspect that the security of the Wallet has been compromised or that you, or any third party, have used, or intend to use the Wallet in a grossly negligent way or for fraudulent or other illegal purposes;</li>
          <li>we believe that your use of the Wallet may result in harm to us or our systems;</li>
          <li>we believe that your continued use of the Wallet may damage our reputation;</li>
          <li>you suffer an Insolvency Event or you cease or threaten to cease to carry on your business;</li>
          <li>we are required to do so under Applicable Law or if we believe that your continued use of the Wallet may be in breach of Applicable Law;</li>
          <li>we cannot process some or all of your Transactions due to the actions of third parties;</li>
          <li>you have breached an important part of this Agreement or have repeatedly breached any term of this Agreement and have failed to resolve it in a timely manner.</li>
        </ul>
        <p className="text-gray-800">
          <strong>10.5.</strong> If we do suspend, restrict or terminate the Wallet then, if we are legally allowed to, we or Program Manager will notify you in advance or as soon as possible afterwards. We may advise anyone involved in the
          Transaction if a suspension has taken place. If possible, we or Program Manager will provide the reasons for the suspension, restriction, termination or refusal to execute a Transaction. If we suspend or block your Wallet, we will unblock
          it as soon as the reasons for blocking it no longer exist.
        </p>
        <p className="text-gray-800">
          <strong>10.6.</strong> Once your Wallet is closed, and subject to any legal obligations that we have to comply with, you will be able to gain access to the funds in the Wallet at any time within six years from the date that this Agreement
          ends.
        </p>
        <p className="text-gray-800">
          <strong>10.7.</strong> If you owe us any funds or Fees when you request your Available Balance, we shall have the absolute right to deduct those funds or Fees from the funds held in your Wallet.
        </p>
        <p className="text-gray-800">
          <strong>10.8.</strong> Any termination or expiry of the Agreement, howsoever caused, shall be without prejudice to any obligations or rights of either of the parties which may be accrued prior to termination or expiry and shall not affect
          any provision of the Agreement which is expressly or by implication intended to come into effect on, or to continue in effect after, such termination or expiry.
        </p>
        <p className="text-gray-800">
          <strong>10.9.</strong> The Contract Holder will be responsible for ensuring that all Wallet Users have been notified of termination of the Agreement.
        </p>
      </section>

      <section id="foreign-exchange" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">11. Foreign Exchange</h3>
        <p className="text-gray-800">
          <strong>11.1.</strong> You can receive payments into the Wallet and make payments out of the Wallet in Pounds Sterling (GBP). You are not permitted to make payments in other currencies.
        </p>
      </section>

      <section id="corporate-opt-out" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">12. Corporate Opt-Out</h3>
        <p className="text-gray-800">
          <strong>12.1.</strong> You agree that the following regulations of the PSRs do not apply to this Agreement:
        </p>
        <ul className="list-disc pl-5 text-gray-800">
          <li>(a) 17 to 37 inclusive;</li>
          <li>(b) 39(1);</li>
          <li>(c) 41(4), 49;</li>
          <li>(d) 51, 53, 54, 57; and</li>
          <li>(e) 65.</li>
        </ul>
        <p className="text-gray-800">
          <strong>12.2.</strong> You agree that you will notify us no later than 1 week after the debit date, on becoming aware of any unauthorised or incorrectly executed payment transaction and regulation 48 (notification of unauthorised or
          incorrectly executed payment transactions) of the PSRs is varied accordingly.
        </p>
      </section>

      <section id="our-liability" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">13. Our Liability</h3>
        <p className="text-gray-800">
          <strong>13.1.</strong> We shall not be liable for any Loss arising:
        </p>
        <ul className="list-disc pl-5 text-gray-800">
          <li>unless directly caused by our negligence, wilful default or fraud;</li>
          <li>where you have acted fraudulently;</li>
          <li>where you do not quickly notify us of security issues on your Wallet (e.g. loss of your password or other Security Details);</li>
          <li>from any loss of profits, loss of business, or any indirect, consequential, special or punitive losses;</li>
          <li>for losses arising from any cause beyond our control and the effect of which is beyond our control; or</li>
          <li>
            if a Transaction was unauthorised but you have failed to notify us in the time period required or if it arises due to your default, with intent or negligence, as a result of compromised security of your Wallet or you have otherwise failed
            to comply with your obligations to use your Wallet in accordance with this Agreement.
          </li>
        </ul>
        <p className="text-gray-800">
          <strong>13.2.</strong> Where funds are incorrectly deducted from your Wallet due to our default, our liability shall be limited to payment to you of an equivalent amount.
        </p>
        <p className="text-gray-800">
          <strong>13.3.</strong> Nothing in this Agreement shall exclude or limit our liability for death or personal injury resulting from our negligence or fraud.
        </p>
        <p className="text-gray-800">
          <strong>13.4.</strong> To the extent permitted by law, all conditions or warranties implied by law, statute or otherwise are expressly excluded.
        </p>
        <p className="text-gray-800">
          <strong>13.5.</strong> The above exclusions and limitations set out in this clause shall apply to any liability of our affiliates such as our suppliers, contractors, distributors and any of their respective affiliates (if any), to you,
          which may arise in connection with this Agreement.
        </p>
      </section>

      <section id="complaints" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">14. Complaints</h3>
        <p className="text-gray-800">
          <strong>14.1.</strong> The Wallet Program is managed by Program Manager. If you would like to make a complaint about the Wallet, please send an email to Program Manager’s Customer Services department at{" "}
          <a href="mailto:info@orenda.finance" className="text-blue-500">
            info@orenda.finance
          </a>
          .
        </p>
        <p className="text-gray-800">
          <strong>14.2.</strong> If, having received a response from our Customer Services Team, you are unhappy with the outcome you can escalate your complaint to TransactPay’s Complaints Department at{" "}
          <a href="mailto:complaints@transactpay.com" className="text-blue-500">
            complaints@transactpay.com
          </a>
          .
        </p>
        <p className="text-gray-800">
          <strong>14.3.</strong> We will make every effort to reach a resolution to your complaint. If we are unable to resolve your issue to your satisfaction we will explain the reasoning behind our decision.
        </p>
        <p className="text-gray-800">
          <strong>14.4.</strong> In the unlikely event that we are unable to resolve your issue you have the right to refer your complaint to the Gibraltar Financial Services Commission at: Payment Services Team, Gibraltar Financial Services
          Commission, PO Box 940, Suite 3 Ground Floor, Atlantic Suites, Europort Avenue, Gibraltar or email{" "}
          <a href="mailto:psdcomplaints@fsc.gi" className="text-blue-500">
            psdcomplaints@fsc.gi
          </a>
          .
        </p>
        <p className="text-gray-800">
          <strong>14.5.</strong> Microenterprises may additionally refer an unresolved complaint to the Gibraltar Financial Services Ombudsman at the following address: The Financial Services Ombudsman, Office of the Ombudsman, 10 Governor’s Lane,
          Gibraltar and at the following website:{" "}
          <a href="https://www.ombudsman.org.gi" className="text-blue-500" target="_blank" rel="noopener noreferrer">
            www.ombudsman.org.gi
          </a>
          . In such an instance, TPL is required to co-operate with any investigation and resolution procedure conducted by the Ombudsman and may be required to accept the outcome of such resolution procedure.
        </p>
      </section>

      <section id="general-communication" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">15. General Communication</h3>
        <p className="text-gray-800">
          <strong>15.1.</strong> When we or Program Manager communicate with you, we’ll do it by email using the contact details you provide on the Corporate Account Platform.
        </p>
        <p className="text-gray-800">
          <strong>15.2.</strong> You may contact Customer Services via the details which are set out in the Schedule.
        </p>
      </section>

      <section id="personal-data" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">16. Personal Data</h3>
        <p className="text-gray-800">
          <strong>16.1.</strong> TransactPay will collect certain information about the Wallet User in order to operate the Wallet Program. Your provision of such Personal Data and our processing of that data is necessary for each of us to carry out
          our obligations under this Agreement. At times, the processing may be necessary so that we can take certain steps, at your request, prior to entering into this Agreement. If you fail to provide the Personal Data which we request, we will
          take steps to terminate this Agreement in accordance with clause 10.4(iii) above.
        </p>
        <p className="text-gray-800">
          <strong>16.2.</strong> We will manage and protect your personal data in accordance with all applicable data protection laws. For full and comprehensive information about when and why we collect personal information about Wallet Users, how
          we use it and the conditions under which we may disclose it, please refer to our Privacy Policy which is provided to you at the time the Personal Data is collected.
        </p>
      </section>

      <section id="right-to-change" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">17. Changes to this Agreement</h3>
        <p className="text-gray-800">
          <strong>17.1.</strong> We may, at Our discretion, alter this Agreement at any time.
        </p>
        <p className="text-gray-800">
          <strong>17.2.</strong> In accordance with our rights under the PSRs, our notice period for informing you of any change shall not be 2 months but we shall instead instruct Program Manager to give You 30 (thirty) days’ prior notice by post or
          email before We make the change, unless the change is required to be implemented earlier by any Applicable Law or regulation, or if it relates to a change in the exchange rate, in which case the change can be made immediately. The version
          of this Agreement displayed on the App and Corporate Account Platform at any time shall constitute the binding version and shall render any previous one obsolete. You understand that the App and the Corporate Account Platform should
          regularly be checked.
        </p>
        <p className="text-gray-800">
          <strong>17.3.</strong> If You do not agree to the change, You should terminate the Agreement in accordance with the provisions of this Agreement. If You do not do so We will assume that You agree to the change and it will be implemented
          upon the expiry of the notice period.
        </p>
      </section>

      <section id="language" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">18. Language</h3>
        <p className="text-gray-800">
          Only the English language version of this Agreement, any communications that we send to you and any content on the App and Corporate Account Platform will apply. If we translate this Agreement or any other content into another language, the
          translation is for reference only.
        </p>
      </section>

      <section id="governing-law" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">19. Governing Law</h3>
        <p className="text-gray-800">This Agreement, and any disputes which arise under it, shall be exclusively governed and construed in accordance with the laws of Gibraltar.</p>
      </section>

      <section id="jurisdiction" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">20. Jurisdiction</h3>
        <p className="text-gray-800">You agree to the exclusive jurisdiction of the courts of Gibraltar.</p>
      </section>

      <section id="miscellaneous" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">21. Miscellaneous</h3>
        <ul className="list-disc pl-5 text-gray-800 space-y-2">
          <li>
            <strong>21.1.</strong> Any delay or failure to exercise any right or remedy under this Agreement by us shall not be construed as a waiver of that right or remedy or preclude its exercise at any subsequent time.
          </li>
          <li>
            <strong>21.2.</strong> The Wallet is a payment service product and not a deposit or credit product and, as such, is not governed by the Deposit Security Scheme of Gibraltar. However, we will safeguard your funds so that they are protected
            by Applicable Law if we become insolvent.
          </li>
          <li>
            <strong>21.3.</strong> If any provision of this Agreement is deemed unenforceable or illegal, the remaining provisions will continue in full force and effect.
          </li>
          <li>
            <strong>21.4.</strong> You may not assign or transfer any of your rights and/or benefits under this Agreement and you shall be the sole party to the contract between us. You will remain liable until your Account is closed and all sums due
            under this Agreement have been paid by you in full. We may assign our rights and benefits under this Agreement to a third party and may subcontract any of our obligations under this Agreement.
          </li>
          <li>
            <strong>21.5.</strong> The Wallet is provided by Transact Payments Limited pursuant to its licence from the Gibraltar Financial Services Commission as an electronic money institution and to undertake payment services.
          </li>
          <li>
            <strong>21.6.</strong> Program Manager administers the Wallet provided by TransactPay and is available to give you customer service support if you have any queries. Program Manager will also conduct activities such as sponsorship,
            marketing, and providing the IT platform and will carry out due diligence on you.
          </li>
        </ul>
      </section>

      <section id="schedule" className="w-full px-5 my-8 scroll-mt-20">
        <h3 className="text-2xl my-4">Schedule to Orenda Wallet Terms</h3>
        <p className="text-gray-800">This schedule (“Schedule”), together with the Wallet Terms govern the use of your Wallet. The Schedule and the Terms are referred to collectively as the Agreement.</p>
        <p className="text-gray-800">
          You will be asked to confirm Your acceptance of this Agreement when you apply for a Wallet via the Corporate Account Platform. If you refuse to accept this Agreement, We will not be able to open a Wallet for you.
        </p>
        <p className="text-gray-800">Unless specifically stated otherwise, words and expressions in this Schedule have the same meaning and interpretation as defined in the Wallet Terms.</p>
        <h4 className="text-xl my-4">Definitions</h4>
        <ul className="list-disc pl-5 text-gray-800">
          <li>
            <strong>Denominated Currency:</strong> GBP
          </li>
          <li>
            <strong>Permitted Territory:</strong> United Kingdom
          </li>
        </ul>
        <h4 className="text-xl my-4">Customer Services</h4>
        <p className="text-gray-800">The Customer Service Department can be contacted via the below channels:</p>
        <ul className="list-disc pl-5 text-gray-800">
          <li>
            By e-mail:{" "}
            <a href="mailto:info@orenda.finance" className="text-blue-500">
              info@orenda.finance
            </a>
          </li>
          <li>By post: St Martins House, 1 Gresham Street, London, England, EC2V 7BX</li>
          <li>Via phone number: +44 161 524 0445</li>
        </ul>
        <h4 className="text-xl my-4">Wallet Fees</h4>
        <table className="min-w-full bg-white border border-gray-200 mt-4">
          <thead>
            <tr>
              <th className="px-4 py-2 border-b text-left">Fee Type *</th>
              <th className="px-4 py-2 border-b text-left">Fees (GBP)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="px-4 py-2 border-b">Account Onboarding Fee</td>
              <td className="px-4 py-2 border-b">575.00</td>
            </tr>
            <tr>
              <td className="px-4 py-2 border-b">Monthly Account Fee</td>
              <td className="px-4 py-2 border-b">250.00</td>
            </tr>
            <tr>
              <td className="px-4 py-2 border-b">Pay In Fee FPS</td>
              <td className="px-4 py-2 border-b">0.50 + 0.5%</td>
            </tr>
            <tr>
              <td className="px-4 py-2 border-b">Pay Out Fee FPS</td>
              <td className="px-4 py-2 border-b">0.50 + 0.5%</td>
            </tr>
            <tr>
              <td className="px-4 py-2 border-b">Pay In Fee BACS</td>
              <td className="px-4 py-2 border-b">2.00 + 0.5%</td>
            </tr>
          </tbody>
        </table>
        <p className="my-4 mx-2">* Maximum fee that can be charged.</p>
      </section>
    </div>
  );
};

export default TermsAndConditions;
